import AutomatonNameCell from './AutomatonNameCell';

export default AutomatonNameCell;
